import React, { useEffect, useRef, useState } from "react";
import Hls from "hls.js";
import "./CameraStream.css";

const CameraStream = ({
  draggable,
  url
}) => {
  const videoRef = useRef(null);
  const hlsRef = useRef(null);
  const retryRef = useRef(null);

  const [status, setStatus] = useState("loading");

  const hlsUrl = `https://sama-tech.ae/hls/camera1/index.m3u8?cookieCheck=1`;

  const startPlayer = () => {
    const video = videoRef.current;

    if (!video) return;

    if (hlsRef.current) {
      hlsRef.current.destroy();
      hlsRef.current = null;
    }

    setStatus("loading");

    if (Hls.isSupported()) {
      const hls = new Hls({
        liveDurationInfinity: true,
        lowLatencyMode: true
      });

      hlsRef.current = hls;

      hls.loadSource(hlsUrl);

      hls.attachMedia(video);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        video.play().catch(() => { });
        setStatus("online");
      });

      hls.on(Hls.Events.ERROR, (_, data) => {
        console.error("HLS Error", data);

        if (data.fatal) {
          setStatus("offline");

          if (!retryRef.current) {
            retryRef.current = setTimeout(() => {
              retryRef.current = null;
              startPlayer();
            }, 5000);
          }
        }
      });
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = hlsUrl;

      video.addEventListener("loadedmetadata", () => {
        video.play().catch(() => { });
        setStatus("online");
      });
    }
  };

  useEffect(() => {
    startPlayer();

    return () => {
      if (hlsRef.current) {
        hlsRef.current.destroy();
      }

      if (retryRef.current) {
        clearTimeout(retryRef.current);
      }
    };
  }, [hlsUrl]);

  return (
    <div
      className={`widget-container camera-stream-widget ${draggable ? "is-draggable" : "not-draggable"
        }`}
      draggable={draggable}
      onDragStart={(e) => {
        const id = e.target.closest(".widget")?.id;
        if (!id) return;

        const rect = e.target.getBoundingClientRect();
        const offsetX = e.clientX - rect.x;
        const offsetY = e.clientY - rect.y;

        let dragData =
          `camera-stream;${id};${offsetX};${offsetY};`;

        dragData += id.startsWith("base") ? "add" : "move";

        e.dataTransfer.setData("text/plain", dragData);
      }}
    >
      <div className="camera-stream-container">
        <video
          ref={videoRef}
          autoPlay
          muted
          playsInline
          controls={false}
          className="camera-stream-video"
        />

        {status !== "online" && (
          <div className="camera-stream-overlay">
            {status === "loading"
              ? "Connecting..."
              : "Camera Offline"}
          </div>
        )}
      </div>
    </div>
  );
};

export default CameraStream;